<script setup lang="ts">
import { defineProps } from "vue";
import VersionDisplay from "./VersionDisplay.vue";

defineProps<{
  msg: string;
}>();
</script>

<template>
  <div class="greetings">
    <div class="version-text">
      <VersionDisplay displayMode="text" />
    </div>
    <!--    <h3>-->
    <!--      <span class="pink">{{ msg }}</span><br/>-->
    <!--    </h3>-->
    <!--    <p>-->
    <!--      <a href="https://dresdencondensates.org/" target="_blank" rel="noopener">Dresden Condensate</a><br/>-->
    <!--      <a href="https://cd-code.org/" target="_blank" rel="noopener">CD-CODE</a>-->
    <!--    </p>-->
  </div>
</template>

<style scoped>
h1 {
  font-weight: 500;
  font-size: 2.6rem;
  top: -10px;
}

h3 {
  font-size: 1.2rem;
}

.greetings h1,
.greetings h3,
.greetings p {
  text-align: center;
}

.version-text {
  text-align: center;
  padding: 10px 0;
  margin-top: 10px;
}

@media (min-width: 1024px) {
  .greetings h1,
  .greetings h3,
  .greetings p {
    padding-top: 20px;
    font-size: 1.3rem;
    text-align: left;
  }
}
</style>
